import { camelize } from '../../utils/index';
import styles from './styles';

const getChipStyle = (tag: string, clickable: boolean, selected: boolean) => {
  switch (tag) {
    case 'text':
      if (clickable) {
        if (selected) {
          return { ...styles.text, ...styles.chipSelected };
        }

        return { ...styles.text, ...styles.chipSelectable };
      }

      return styles.text;
    case 'positive':
    case 'negative':
    case 'exchanged':
    case 'error':
      return { ...styles.status, ...styles[tag] };
    case 'recommended':
    case 'reduced':
    case 'last-viewed':
    case 'zero-deposit':
    case 'recently-sold':
    case 'recently-let':
    case 'recently-added':
    case 'red':
    case 'green':
      return { ...styles.property, ...styles[camelize(tag)] };
    default:
      return {};
  }
};

export default getChipStyle;
